import styled from 'styled-components/macro'
import { ifProp } from 'styled-tools'
import { media } from '../../../utils/styles'

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 1em 0 .5em;
  width: 100%;

  & + & {
    margin-top: .5em;
  }

  ${media('tablet')`
    margin-left: 1.5em;
    margin-right: 1.5em;
    width: ${ifProp('full', 'calc(100% - 3em)', 'calc(50% - 3em)')};
  `}
`

export default Wrapper
